import { render } from "./SimulationPage.vue?vue&type=template&id=d53e7330"
import script from "./SimulationPage.vue?vue&type=script&lang=js"
export * from "./SimulationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__